<template>
  <div class="easy-loading">
    <span v-for="n in 8" :key="n"></span>
  </div>
</template>

<script>
export default {
  name: 'easy-loading',
};
</script>

<style lang="scss">
$size: 20px;
$dot: 4px;
$color: $easyColorSecondary;

.easy-loading {
  position: relative;
  width: $size;
  height: $size;
}

.easy-loading span {
  position: absolute;
  width: $dot;
  height: $dot;
  background: $color;
  border-radius: 50%;
  top: 50%;
  left: 0%;
  transform-origin: calc($size / 2) 0;
  animation: easy-loading 1.2s linear infinite;
}

@for $i from 1 through 8 {
  .easy-loading span:nth-child(#{$i}) {
    transform: rotate(#{($i - 1) * 45}deg) translate(0, -#{($size / 2)});
    animation-delay: -#{1.2 - ($i * 0.15)}s;
  }
}

@keyframes easy-loading {
  0% { opacity: 1; }
  100% { opacity: 0.2; }
}
</style>
